let language = {
    // SHIPPING
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-TITLE":"Shipping",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-MESSAGE-TITLE":"Address Information",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-SHIPPING-BOX-TITLE":"Shipping Address:",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-RECEIVER-BOX-TITLE":"Receiver:",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-RECEIVER-BOX-CHANGE-BUTTON":"Change Address",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-RECEIVER-BOX-ERROR-TIPS":"The address's postal code entered does not match the selected country/region.",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-BILLING-BOX-TITLE":"Billing Address:",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-BILLING-BOX-OWNER":"Owner:",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-BILLING-BOX-OWNER-CHANGE-BUTTON":"Change Address",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX":"Delivery Method",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-TITLE":"Delivery Method:",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-TIME":"Estimated delivery time:",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-TIME-PRODUCTION":"Production time",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-TIME-WORKING-DAY":"working days",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-TIME-TRANSPORTATION":"transportation time",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-TIME-RECEIPT":"Estimated receipt time:",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-SHIPPING-FEE":"Shipping fee:",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-NOTE-TITLE":"Note :",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-NOTE-ITEM-1": `1.Delivery time is for customer reference only, {{appName}} can not guarantee delivery standards for logistics services.`,
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-BOX-NOTE-ITEM-2":`2.In remote areas,delivery times are extended 3-5 days outside normal transit time.`,
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-BUTTON-CANCEL":"Cancel",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-BUTTON-CONTINUE":"Continue",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-BUTTON-REVIEWANDPQY":"Review and payment",
    
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-NONE-CONTENT": "None",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-NOT-SUPPORT": "The shipping address for this order is outside {{appName}}'s service coverage area.",
    "DIRECT-CHECKOUT-ENTRY-SHIPPING-DELIVERY-METHOD-NOT_SUPPORT": "Used shipping method: {{shipmentMethod}} (The selected shipping method is not available for this country or region.)",
    
    // ORDER
    "DIRECT-CHECKOUT-ENTRY-ORDER-TITLE":"Place Order",
    "DIRECT-CHECKOUT-ENTRY-ORDER-MESSAGE-TITLE":"Product Information",
    "DIRECT-CHECKOUT-ENTRY-ORDER-PRODUCT-DESCRIPTION":"Item Description",
    "DIRECT-CHECKOUT-ENTRY-ORDER-TABLE-HEADER-QUANTITY":"Quantity",
    "DIRECT-CHECKOUT-ENTRY-ORDER-TABLE-HEADER-UNIT-PRICE":"Unit Price",
    "DIRECT-CHECKOUT-ENTRY-ORDER-TABLE-HEADER-TOTAL-PRICE":"Total Price",
    "DIRECT-CHECKOUT-ENTRY-ORDER-BUTTON-BACK":"Back",
    "DIRECT-CHECKOUT-ENTRY-ORDER-BUTTON-CONTINUE":"Continue",
    "DIRECT-CHECKOUT-ENTRY-ORDER-FOOTER-TOTAL":"Total:",
    // PAYMENT
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-TITLE":"Payment",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-UNITED":"United Price",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-MESSAGE-TITLE":"Payment Method",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-TOTAL":"Total:",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-COUPON":"Coupon Code:",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-COUPON-BUTTON-REDEEM":"Redeem",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-COUPON-TIPS-ONLY":"Only",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-COUPON-TIPS-ALLOWED":"coupon allowed per order",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-SUBTOTAL":"Products and Services:",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-TAX":"Tax:",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-IMPORT-SERVICE-FEE":"Import Service:",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-SHIPPING-FEE":"Shipping:",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-FOOTER-TOTAL":"Total Due:",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-BUTTON-BACK":"Back",
    "DIRECT-CHECKOUT-ENTRY-PAYMENT-BUTTON-PAYMENT":"Payment",
    "DIRECT-CHECKOUT-ENTRY-MODAL-BUTTON-CANCEL":"Cancel",
    "DIRECT-CHECKOUT-ENTRY-MODAL-BUTTON-SAVE":"SAVE",
    "DIRECT-CHECKOUT-TITLE":"Payment method:",
    "DIRECT-CHECKOUT-SHIPMENT-METHOD":"EShopper shippment method:",
    "DIRECT-CHECKOUT-SHIPMENT-METHOD-TIPS":`(this shipping method is not support in {{appName}}, you should change it before you payment.)`,
    "DIRECT-CHECKOUT-INFO-PRICE":"Price:",
    "DIRECT-CHECKOUT-INFO-PRODUCTS": "Products",
    "DIRECT-CHECKOUT-INFO-WEIGHT":"Weight:",
    "DIRECT-CHECKOUT-INFO-TOTAL-WEIGHT":"Total weight:",
    "DIRECT-CHECKOUT-INFO-PAYMENT-SUBTOTAL":"Payment subtotal:",
    "DIRECT-CHECKOUT-INFO-PAYMENT-TAX":"Payment tax:",
    "DIRECT-CHECKOUT-INFO-PAYMENT-SHIPPING-FEE":"Payment shipping fee:",
    "DIRECT-CHECKOUT-INFO-PAYMENT-TOTAL":"Payment total:",
    "DIRECT-CHECKOUT-INFO-BUTTON-CANCEL":"CANCEL",
    "DIRECT-CHECKOUT-INFO-BUTTON-PAYMENT":"Payment",
    "DIRECT-CHECKOUT-INFO-BUTTON-BUTTON-CONFIRMPAY":"confirm and pay",
    "DIRECT-CHECKOUT-INFO-PAYMENT-PREVIEW":"PREVIEW",
    // 免密支付
    "DIRECT-CHECKOUT-PAYMENT-AUTO-TIP": "Add this primary billing method for your {{appName}} account. It'll be the default we use to charge you for future transactions.",
    "DIRECT-CHECKOUT-PAYPAL-INTRO-TIP": "PayPal accepts all major credit cards. You do not need a Paypal account to use this payment method.",
    "DIRECT-CHECKOUT_PAYMENT_BANK_TRANSFER_DES":"To pay, click \"{{payBtnText}}\" and follow the transfer instructions."
};

export { language }